import { ModelBase } from "../core/modelbase";

export class Role extends ModelBase {
  roKey: string;
  roName: string;
  roCode: string;
  roDescription: string;
}
